[
  {
    "key": "ancient",
    "name": "Ancient",
    "description": "Scattered settlements learning to farm, build and remember."
  },
  {
    "key": "classical",
    "name": "Classical",
    "description": "Cities become states, and states begin to write down what they believe."
  },
  {
    "key": "medieval",
    "name": "Medieval",
    "description": "Faith, fealty and the slow accumulation of craft."
  },
  {
    "key": "renaissance",
    "name": "Renaissance",
    "description": "Old learning recovered, new worlds charted, and the printed page."
  },
  {
    "key": "industrial",
    "name": "Industrial",
    "description": "Coal, iron and steam, and the factory town."
  },
  {
    "key": "modern",
    "name": "Modern",
    "description": "Electricity, flight and the atom."
  }
]
